<template>
  <div>
    <Dialog
      width="500px"
      :mobileRenderType="createRenderType == 'pc' ? '' : 'drawerDialog'"
      :customClass="`${createRenderType}-cancel-dialog cancel-dialog`"
      :backgroundImage="false"
      background="rgba(95, 95, 134, 0.7)"
      titleAlign="left"
      :visible="dialogVisible"
      @close="onClose"
    >
      <div class="cancel-box">
        <div class="title">{{ $t("credit.manage_payment") }}</div>
        <div class="info">
          <div class="setting-btn pointer flex-center" @click="handleSetting">
            <img src="@/assets/img/credit/setting.png" alt="" />
            <div>
              {{ $t("credit.payment_settings") }}
            </div>
          </div>
          <div
            class="cancel-btn pointer flex-center"
            @click="handleCancelSubscribe"
          >
            <img src="@/assets/img/credit/cancel.png" alt="" />
            <div>
              {{ $t("credit.unsubscribe") }}
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits } from "vue";
import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";

const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);

const emits = defineEmits(["update:visible", "handleCancelSubscribe"]);
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  manageUrl: {
    type: String,
    default: "",
  },
});

const dialogVisible = ref(props.visible);

const onClose = () => {
  dialogVisible.value = false;
  emits("update:visible", false);
};

const handleCancelSubscribe = () => {
  onClose();
  emits("handleCancelSubscribe", false);
};

const handleSetting = () => {
  window.open(props.manageUrl, "_blank");
};
</script>

<style lang="scss" scoped>
.cancel-dialog {
  .cancel-box {
    color: #fff;
    .title {
      font-weight: bold;
    }
  }
  .info {
    padding-top: 16px;
    > div {
      border-radius: 60px;
      height: 60px;
      margin-top: 16px;
      background: rgba(0, 0, 0, 0.2);
      font-size: 16px;
      font-weight: 500;
      img {
        width: 20px;
        height: 20px;
        margin-right: 6px;
      }
    }
    .cancel-btn {
      color: #ff5f74;
    }
  }
}

.pc-cancel-dialog {
  .cancel-box {
    padding: 0 40px 40px;
    .title {
      font-size: 28px;
      line-height: 32px;
    }
  }
}

.mobile-cancel-dialog {
  .cancel-box {
    padding: 0 20px 28px;
    color: #fff;
    .title {
      font-size: 24px;
      line-height: 24px;
    }
  }
}
</style>